/**
 * vue filter
 */

export function moneyFilter(value, reEmpty = false) {
    // budo_log.info("#2 moneyFilter", value, reEmpty)

    if (!value) {
        return reEmpty ? '' : '0';
    }

    // 导出fn有问题 临时处理下
    if (value === '包邮') {
        return '包邮'
    }

    let f = parseFloat(value);
    if (isNaN(f)) {
        return;
    }

    f = Math.round(value * 100) / 10000;
    let s = f.toString();
    let rs = s.indexOf('.');
    if (rs < 0) {
        rs = s.length;
        s += '.';
    }

    while (s.length <= rs + 2) {
        s += '0';
    }

    return s;
}

export function moneyFormatFilter(value, priceName = '') {
    const s = moneyFilter(value);
    let splitPrice = s.split(".");
    return `${splitPrice[0]}.<span style="font-size:14px;">${splitPrice[1]}${priceName}</span>`;
}

export function orderStatusFilter(value) {
    switch (value) {
        case 0:
            return '新订单';
        case 1:
            return '已申请取消';
        case 2:
            return '取消审核中';
        case 3:
            return '已取消';
        case 4:
            return '已完成';
        case 5:
            return '处理中';
        default:
            return '未知';
    }
}

export function orderPayStatusFilter(value) {
    switch (value) {
        case 0:
            return '未支付';
        case 1:
            return '已支付';
        case 2:
            return '退款中';
        case 3:
            return '退款失败';
        case 4:
            return '退款成功';
        default:
            return '未知';
    }
}

export function expressStatusFilter(value) {
    switch (value) {
        case 0:
            return '无需物流';
        case 1:
            return '等待发货';
        case 2:
            return '已发货';
        case 4:
            return '用户已收货';
        default:
            return '未知';
    }
}
